import React from "react";
import Flex from "../Components/Flex";
import Card from "../Components/Card";
import { styled } from "styled-components";

const Help: React.FC = () => {
  return (
    <Wrapper>
      <h1>Help and FAQ Page</h1>
      <Flex $direction="column">
        <Card title="test" />
      </Flex>
    </Wrapper>
  );
};

const Wrapper = styled.div``;

export default Help;
